const map = {
	"./ring_1.svg": 22917,
	"./ring_2.svg": 23782,
	"./ring_3.svg": 94967,
	"./ring_4.svg": 75160,
	"./ring_5.svg": 26377,
	"./ring_6.svg": 11290
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52099;